import axios from "@/lib/axios";

const getTerminateCancels = () => {
  return axios.get("/facility/facility_agreements/terminate_cancels");
}

export default getTerminateCancels;